import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Checkbox,
  FormControlLabel
} from '@mui/material';
import { useFramework } from '../../contexts/FrameworkContext';

/**
 * Component to display details about a framework step.
 * 
 * @param {object} props - Component props
 * @param {object} props.step - The step object to display
 * @returns {JSX.Element} Framework step details component
 */
const FrameworkStepDetails = ({ step }) => {
  const { activeFramework, toggleStepCompletion } = useFramework();

  if (!step || !activeFramework) {
    return null;
  }

  const handleToggleCompletion = (event) => {
    toggleStepCompletion(step.id, event.target.checked);
  };

  return (
    <Card variant="outlined" sx={{ mb: 3 }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <Box>
            <Typography variant="overline" color="text.secondary">
              Framework: {activeFramework.title}
            </Typography>
            <Typography variant="h6" component="h3" gutterBottom>
              {step.number}. {step.title}
            </Typography>
          </Box>
          <FormControlLabel
            control={
              <Checkbox
                checked={step.completed || false}
                onChange={handleToggleCompletion}
              />
            }
            label="Mark as complete"
          />
        </Box>

        {step.call_to_action && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" gutterBottom>
              Call to Action
            </Typography>
            <Typography variant="body2" paragraph>
              {step.call_to_action}
            </Typography>
          </Box>
        )}

        {step.why_it_matters && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" gutterBottom>
              Why It Matters
            </Typography>
            <Typography variant="body2" paragraph>
              {step.why_it_matters}
            </Typography>
          </Box>
        )}

        {step.guidance && (
          <Box>
            <Typography variant="subtitle2" gutterBottom>
              Guidance
            </Typography>
            <Typography variant="body2" paragraph>
              {step.guidance}
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default FrameworkStepDetails;